/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    RECALCULATE_GIFT_CARD_TOTAL,
    APPLY_GIFT_CARD_ACTION,
    APPLY_GIFT_CARD_PROCESS_COMPLETED,
    REMOVE_GIFT_CARD_ACTION,
    REMOVE_GIFT_CARD_PROCESS_COMPLETED,
    RECALCULATE_GIFT_CART_TOTAL_COMPLETED,
} from './GiftCard-ActionTypes';

export const recalculateGiftCardTotal = () => ({
    type: RECALCULATE_GIFT_CARD_TOTAL,
});

export const recalculateGiftCardTotalCompleted = () => ({
    type: RECALCULATE_GIFT_CART_TOTAL_COMPLETED,
});

export const applyGiftCard = (giftcardNumber, giftcardPin, recaptcha, callBackFunc, recaptchaV2, history) => ({
    type: APPLY_GIFT_CARD_ACTION,
    payload: {
        giftcardNumber,
        giftcardPin,
        recaptcha,
        callBackFunc,
        recaptchaV2,
        history,
    },
});

export const applyGiftCardProccessCompleted = () => ({
    type: APPLY_GIFT_CARD_PROCESS_COMPLETED,
});

export const removeGiftCard = (giftcardNumber, giftCardId, history, pageType) => ({
    type: REMOVE_GIFT_CARD_ACTION,
    payload: {
        giftcardNumber,
        giftCardId,
        history,
        pageType,
    },
});

export const removeGiftCardProccessCompleted = () => ({
    type: REMOVE_GIFT_CARD_PROCESS_COMPLETED,
});

export default {};
